import React, { useMemo, useEffect } from "react";
import { Label, FormFeedback, FormGroup } from "reactstrap";
import Select from "react-select/async";
import { getUsersDefault } from "common/services/users.service";
import { normalize } from "common/lib/normalize";
import {
  GroupBase,
  OptionsOrGroups,
} from "react-select/dist/declarations/src/types";

const SelectConductedByUser = ({
  validation,
  isUpdate,
  selectedId,
}: {
  validation: any;
  isUpdate?: boolean;
  selectedId?: number;
}) => {
  const customSelectStyles = {
    control: (styles: any) => ({
      ...styles,
      borderColor:
        validation.touched.conductedBy && validation.errors.conductedBy
          ? "red"
          : "#ced4da",
      "&:hover": {
        borderColor:
          validation.touched.conductedBy && validation.errors.conductedBy
            ? "red"
            : "#ced4da",
      },
    }),
  };

  const [data, setData] = React.useState<any>([]);
  const [loading, setLoading] = React.useState<boolean>(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        let filters = {};
        if (isUpdate) {
          filters = {
            conductedBy: selectedId,
          };
        }
        const response = await getUsersDefault({
          pagination: {
            page: 1,
            pageSize: 100,
          },
          filters,
        });
        setData(normalize(response.data));
      } catch (e) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [isUpdate, selectedId]);

  const options = useMemo(() => {
    return data.map((el: any) => {
      return {
        value: el?.id,
        label: `${el?.firstName} ${el?.lastName}`,
      };
    });
  }, [data]);

  return (
    <FormGroup>
      <Label htmlFor="conductedBy-field" className="form-label">
        Conducted by
      </Label>
      <Select
        name="conductedBy"
        id="conductedBy"
        value={
          validation.values.conductedBy.value
            ? validation.values.conductedBy
            : null
        }
        placeholder="Select conducted by"
        validate={{
          required: { value: true },
        }}
        onChange={(value: any) => {
          validation.setFieldValue("conductedBy", value);
          validation.setFieldError("conductedBy", "");
        }}
        defaultOptions={options}
        // @ts-ignore
        loadOptions={(
          inputValue: string,
          callback: (options: OptionsOrGroups<any, GroupBase<any>>) => void
        ) => {
          return getUsersDefault({
            pagination: {
              page: 1,
              perPage: 100,
            },
            filters: {
              $or: [
                {
                  firstName: {
                    $containsi: inputValue,
                  },
                },
                {
                  lastName: {
                    $containsi: inputValue,
                  },
                },
              ],
            },
          }).then((result: any) => {
            const parsedData = normalize(result.data);
            callback(
              parsedData.map((el: any) => {
                return {
                  value: el?.id,
                  label: `${el?.firstName} ${el?.lastName}`,
                };
              })
            );
          });
        }}
        onBlur={() => validation.setFieldTouched("conductedBy", true)}
        className={
          validation.touched.conductedBy && validation.errors.conductedBy
            ? "is-invalid"
            : ""
        }
        styles={customSelectStyles}
        isLoading={loading}
      />
      <FormFeedback>{validation.errors.conductedBy?.value}</FormFeedback>
    </FormGroup>
  );
};

export default SelectConductedByUser;
